import { scrollMainContentToTop } from '@/shared/utils/scrollMainContent';

import React from 'react';

import { useLocation } from 'react-router-dom';

export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    scrollMainContentToTop();
  }, [pathname]);

  return null;
};
